export default __webpack_public_path__ + "static/media/welcome-bg3.9e9c1c65.png";